// Load and expose jQuery
require('expose-loader?ocmsJQuery!jquery');

// Load js-cookie
require('jsCookie');

// Get custom cookie functions
const cookie = require('../../../common/tools/Cookie');

// Map js-cookie to jQuery for retro-compatibility
window.$.cookie = cookie.retroCookie;
window.jQuery.cookie = cookie.retroCookie;
window.ocmsJQuery.cookie = cookie.retroCookie;

// Load SASS so the CSS gets generated
// require('sass/header.desktop.scss');
require('sass/desktop.scss');

// Load SVG images to generate SVG sprites
require('svg/logo.svg');
require('svg/reward-logo2.svg');

const events = require('../../../common/Events');
const ui = require('../../../common/Ui');
const utils = require('../../../common/Utils');
const addToDataLayer = require('../../../common/DataLayer').addToDataLayer;
const header = require('../../organism/header');
const cart = require('../../Cart');
const wishlist = require('../../../common/Wishlist');

utils.browserDetection = require('../../../common/tools/BrowserDetection');

// Set or merge OCMS global var
window.OCMS = window.OCMS || {};
Object.assign(window.OCMS, {
  events,
  ui,
  utils,
  addToDataLayer,
  header,
  cart,
  wishlist,
});

const init = require('./init').init;

// Initialization
init();



// WEBPACK FOOTER //
// ./js/desktop/entries/header/index.js